export const imgStyle = {
  //75
  width: '110px',
  objectFit: 'cover',
  height: '120px',
};

export const noWrap = {
  whiteSpace: 'nowrap',
};
export const noOverflow = {
  marginBottom: '8px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

export const priceStyle = {
  position: 'absolute',
  left: '0',
  bottom: '16px',
  background: 'white',
  paddingRight: '16px',
};

export const topDivStyle = {
  padding: '26px 10px 36px 10px',
  background: '#EBE9F6',
  position: 'relative',
};
